var map = {
	"./aggregators.svg": "758e",
	"./data-management.svg": "3edf",
	"./data-sharing.svg": "4303",
	"./electronic-facilities.svg": "6ade",
	"./other.svg": "a2a4",
	"./physical-facilities.svg": "4afb",
	"./sample-facilities.svg": "f875",
	"./security.svg": "83cc",
	"./training.svg": "2a71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "731c";